import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  forwardRef,
  inject,
} from '@angular/core';
import { FormControl, FormGroup, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'workflow-finx-switch',
  templateUrl: './workflow-finx-switch.component.html',
  styleUrls: ['./workflow-finx-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WorkflowFinxSwitchComponent),
      multi: true,
    },
  ],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule],
})
export class WorkflowFinxSwitchComponent implements OnInit {
  private cd = inject(ChangeDetectorRef);

  @Input() checkedValue: boolean;
  @Output() checkedValueChange = new EventEmitter<boolean>();
  @Input() isSmallSwitchButton = false;
  @Input() formControlName: string;
  @Input() formGroup: FormGroup;
  @Input() isDisabled: boolean;
  public readonly switchControl = new FormControl();
  ngOnInit() {
    this.switchControl.valueChanges.subscribe((inputString) => {
      this.onModelChange(inputString);
      this.onModelTouched();
      this.cd.detectChanges();
    });
    if (this.formGroup && this.formControlName) {
      const formControl = this.formGroup.get(this.formControlName);
      if (formControl) {
        this.checkedValue = formControl.value;
      }
    }
  }
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
  onModelChange: Function = () => {};
  // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-empty-function
  onModelTouched: Function = () => {};

  writeValue(value: boolean): void {
    value = value ?? false;
    this.checkedValue = value;
    // update internal FormControl without emitting a change (avoid triggering valueChanges on init)
    this.switchControl.setValue(value, { emitEvent: false });
    this.cd.markForCheck();
  }
  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleClick(event: any) {
    this.checkedValue = event.target.checked;
    this.onModelChange(this.checkedValue);
    this.checkedValueChange.emit(this.checkedValue);
  }
}
